import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=788309bc&scoped=true&"
import script from "./BrandDetail.vue?vue&type=script&lang=js&"
export * from "./BrandDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrandDetail.vue?vue&type=style&index=0&id=788309bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788309bc",
  null
  
)

export default component.exports